import React from 'react';
import Footer from './Footer.js';
import * as utils from '../common/Utils.js';
import { useConfig } from '../contexts/ConfigContext.js';
import { useIsAdmin } from '../hooks/useIsAdmin.js';

const SignUp = () => {
  const config = useConfig();
  const SEASON = config.currentSeason;
  const isAdmin = useIsAdmin();

  return (
    <div className="HomepageUpdated signup-flow">
      <div className="league-content">
        <div className="league-homepage">

          <nav className="homepage-nav">
            <p className="homepage-nav-label">Season {utils.toRomanNumeral(parseInt(SEASON))} Sign Ups</p>
            {isAdmin && <a className="homepage-anchor-link" href="/signup/all">Signed Up Players</a>}
          </nav>
          <hr className="section-divider" />

          <a className="signup-choice" href="/signup/new">
            <div>
              <p className="league-article-title">New Player</p>
              <p className="article-read-time">New to League Morning Star</p>
            </div>
            <span className="signup-choice-arrow">›</span>
          </a>
          <hr className="section-divider" />

          <a className="signup-choice" href="/signup/returning">
            <div>
              <p className="league-article-title">Returning Player</p>
              <p className="article-read-time">Played in a previous season of League Morning Star</p>
            </div>
            <span className="signup-choice-arrow">›</span>
          </a>
          <hr className="section-divider" />

        </div>
      </div>

      <Footer/>
    </div>
  );
}

export default SignUp;
